export const optionsContactIdd = [
  {
    value: "65",
    label: "+65 (SG)",
  },
  {
    value: "62",
    label: "+62 (ID)",
  },
];
